import { useCallback, useState } from 'react';

import { DEFAULT_ROWS_PER_PAGE } from '../constants/pagination';

/**
 * Local page + page-size state for lists that don't need useListPage's
 * filters/URL sync. `page` is zero-based; add 1 for 1-based APIs.
 * Changing the page size returns to the first page.
 */
export function usePaginationState(initialRowsPerPage: number = DEFAULT_ROWS_PER_PAGE) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPageState] = useState(initialRowsPerPage);

  const setRowsPerPage = useCallback((next: number) => {
    setRowsPerPageState(next);
    setPage(0);
  }, []);

  const resetPage = useCallback(() => setPage(0), []);

  return { page, rowsPerPage, setPage, setRowsPerPage, resetPage };
}

export type PaginationState = ReturnType<typeof usePaginationState>;
